import { LitElement, html, css } from 'lit'

class ListContainer extends LitElement {
  static properties = {
    loading: { type: Boolean, reflect: true, attribute: true }, //Loading/replacing items
    reloading: { type: Boolean, reflect: true, attribute: true }, //Replacing all items
    total: { type: Number, reflect: true },
    prefetch: { type: Boolean },
    nofetch: { type: Boolean }
  }

  constructor() {
    super()
    this.setAttribute('aria-live', 'polite')
    this.addEventListener('search-result', this.handleSearchResult)
    this.addEventListener('filter-update', this.handleFilterUpdate)
    this.addEventListener('paging-update', this.handlePagingUpdate)
    this.addEventListener(
      'filter-item-initialized',
      this.prefetchUrl.bind(this)
    )
    this.pagingContainer = document.querySelector(
      `paging-container[for="${this.id}"]`
    )
    this.loading = false
    this.reloading = false
  }

  firstUpdated() {}

  updated(changedProperties) {
    if (changedProperties.has('loading')) {
      if (this.loading) {
        this.setAttribute('aria-busy', 'true')
      } else {
        this.removeAttribute('aria-busy')
      }
    }
  }

  handleSearchResult(e) {
    const searchValue = e.detail
  }

  createUrl(path, search, pageNo = 0) {
    let url = this.dataset.fetchUrl.split('?')[0]
    let searchParams = new URLSearchParams(this.dataset.fetchUrl.split('?')[1])

    searchParams.set('path', path)
    searchParams.set('initial', this.dataset.initial)

    searchParams = new URLSearchParams({
      ...Object.fromEntries(searchParams),
      ...Object.fromEntries(new URLSearchParams(search)),
    })

    if (pageNo > 0) {
      searchParams.set(this.pagingContainer?.name ?? 'p', pageNo.toString())
    } else {
      searchParams.delete(this.pagingContainer?.name ?? 'p')
    }
    return `${url}?${searchParams.toString()}`
  }

  prefetchUrl(e) {
    if (!this.prefetch) return
    this.fetchResult(this.createUrl(e.detail.url.pathname, e.detail.url.search))
  }

  async handleFilterUpdate(e) {
    const pageNo = 0
    const timeout = setTimeout(() => {
      this.loading = true
      this.reloading = true
    }, 100)
    const cache = e.detail.cache ?? true
    await this.fetchAndUpdateItems(true, pageNo, cache)
    clearTimeout(timeout)
    this.loading = false
    this.reloading = false
  }

  async handlePagingUpdate(e) {
    const pageNo = e.detail.pageNo || 0
    const timeout = setTimeout(() => {
      this.loading = true
    }, 100)
    setTimeout(async() => {
      await this.fetchAndUpdateItems(false, pageNo)
      clearTimeout(timeout)
      this.loading = false
    }, 3000)

  }

  async fetchAndUpdateItems(replace = false, pageNo = 0, cache = true) {
    const result = await this.fetchResult(
      this.createUrl(window.location.pathname, window.location.search, pageNo),
      cache
    )
    this.total = result.total

    if (replace) {
      this.innerHTML = result.html
    } else {
      this.insertAdjacentHTML('beforeend', result.html)
    }
    this.dispatchEvent(
      new CustomEvent('list-updated', {
        bubbles: true,
        detail: { count: this.childElementCount, total: this.total },
      })
    )
  }

  async fetchResult(url, cache = true) {
    let result = this.getResultFromCache(url)
    if (result) return result
    const response = await fetch(url)
    result = {
      total: response.headers.get('total-count'),
      html: await response.text(),
    }
    if (!this.nofetch && cache) {
      this.cacheResult(url, result)
    }
    return result
  }

  cacheResult(key, result) {
    sessionStorage.setItem(key, JSON.stringify(result))
  }

  getResultFromCache(key) {
    return JSON.parse(sessionStorage.getItem(key))
  }

  render() {
    return html` <slot></slot>`
  }
}

customElements.define('list-container', ListContainer)
